import React, { useEffect } from "react";
import { useAuth } from "react-uicomp";
import CompWrapper from "../hoc/compWrapper/CompWrapper.hoc";

// IMAGES
import PLACEHOLDER from "../../assets/images/weather_station.png";
import { TitleB } from "../common/title/Title.common";

const AgrometStationPage = () => {
  const { setHeaderTitle } = useAuth();

  useEffect(() => {
    setHeaderTitle("AgrometStation");
  }, [setHeaderTitle]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <CompWrapper>
      <div>
        <div className="mb-5">
          <TitleB title="Agromet observatory" />
          <p>
            The agromet observatory has been functioning more than 40 years back
            with the following instruments to record the weather parameters.
          </p>
          <div className="mt-3 ml-5">
            <ul>
              <li>Max. &amp; Min. Thermometer</li>
              <li>Wet bulb &amp; dry bulb Thermometer</li>
              <li>Soil thermometer for 5, 10, 20 cm depth</li>
              <li>Windwane</li>
              <li>Robinson’s Cup Anemometer</li>
              <li>Ordinary rain gauge</li>
              <li>Self Recording Rain Gauge</li>
              <li>Sunshine Recorder</li>
              <li>USWB Open pan Evaporimeter</li>
            </ul>
          </div>
          <div className="mt-3">
            <b className="text-bold">
              Besides these, Automatic Weather Station was also established for
              recording the weather parameters.
            </b>
          </div>
        </div>
        <img className="image-showcase" width="60%" src={PLACEHOLDER} />
      </div>
    </CompWrapper>
  );
};

export default AgrometStationPage;
